import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import GTMHelper from '../../../Helpers/gtmHelper';
import OcaService from '../../../Services/OcaService';

import Button from '../../1_Atoms/Button/Button';
import { Svg } from '../../1_Atoms/Svg/Svg';

export const OcaModal = ({financeType, handleClose, isOpen, ...props }) => {
    const summaryCalculator = window.summaryCalculator;
    const { t, i18n } = useTranslation(['general']);

    const ocaService = new OcaService();

    
    function handleExit(e){
        ocaService.sendDataToService(summaryCalculator, financeType);
    }
    return (
        <div className="mz-modal modal" id="ocaModal" aria-hidden={!isOpen}>
            <div className="wrapper">
                <div className="mz-modal__container">
                    <div className="mz-modal__content">
                        <button className="mz-modal__close" aria-label="Close Modal" onClick={() => {
                                handleClose(false)
                                document.querySelector('body').classList.remove('disabled');
                            }}>
                                <Svg
                                    colour="grey"
                                    size={1.93}
                                    svg_list="x"
                                />
                        </button>
                        <div className="mz-modal__text-container">
                            <h3 className="text--center">{t("general:ocaTitle")}</h3>
                            <div className="mz-spacer mz-spacer-s"></div>
                            <p className="text--center">{t("general:ocaContent")}</p>
                            <div className="mz-spacer mz-spacer-s"></div>
                            <div className="mz-container-flex">
                                <Button
                                    className="mz-btn mz-btn--primary mz-btn--red"
                                    label={t("general:ocaButton")}
                                    colour="white"
                                    icon={true}
                                    iconAfter={true}
                                    svg_className=""
                                    svg_list="chevron_small"
                                    size={0.8}
                                    onClick={(e) => {
                                        handleClose(false);
                                        document.querySelector('body').classList.remove('disabled');
                                        handleExit(e);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

OcaModal.defaultProps = {
    handleClose: () => {
    },
};

